import {
  makeStyles,
  shorthands,
  tokens,
  Text,
  mergeClasses,
  CardProps,
  Card,
  CardHeader,
  CardHeaderProps
} from "@fluentui/react-components";
import { OpenRegular } from "@fluentui/react-icons";
import { useQueryClient } from "react-query";

const useStyles = makeStyles({
  card: {
    height: "fit-content",
    maxWidth: "650px"
  },

  caption: {
    color: tokens.colorNeutralForeground3,
  },

  logo: {
    borderRadius: "4px",
    width: "48px",
    height: "48px",
  },

  text: {
    ...shorthands.margin(0),
  },

  header: {
    display: "flex", 
    alignItems: "center", 
    justifyContent: "space-between",
    width: "100%"
  }
});

export interface AppCardProps extends CardProps {
  title: string,
  description: string,
  img: string,
  onClick?: () => void,
  href?: string,
  allowed?: boolean,
  action?: CardHeaderProps["action"],
}

export const AppCard = ({ className, ...props }: AppCardProps) => {
  const styles = useStyles();
  const queryClient = useQueryClient();

  const onClick = () => {
    if (props.allowed === false) {
      queryClient.setQueryData('notificationMessage', {
        intent: "error",
        description: `${props.title} is available only to users with the Global Administrator role assigned. Please contact your company's Administrator`
      });
    }
    else if (props.onClick) {
      props.onClick();
    }
    else if (props.href) {
      window.open(props.href, "_blank");
    }
  }

  return (
    <Card
      {...props}
      className={mergeClasses(className, styles.card)}
      onClick={onClick}
    >
      <CardHeader
        image={
          <img
            className={styles.logo}
            src={props.img}
            alt="App logo"
          />
        }
        header={
          <div
            className={styles.header}
          >
            <Text weight="semibold" size={600}>{props.title}</Text>
            {props.href && <OpenRegular />}
          </div>
        }
        action={props.action}
      />

      <p className={styles.text}>
        {props.description}
      </p>
    </Card>
  );
};